export const required = (value) =>
  value || typeof value === 'number' || typeof value === 'boolean'
    ? undefined
    : 'Required'

export const maxLength = (max) => (value) =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined
export const minLength = (min) => (value) =>
  value && value.length < min ? `Must be ${min} characters or more` : undefined

export const number = (value) =>
  value && isNaN(Number(value)) ? 'Must be a number' : undefined
export const minValue = (min) => (value) =>
  value && value < min ? `Must be at least ${min}` : undefined
export const currency = (value) =>
  value && !/^(?:0|[1-9]\d*)(?:\.(?!.*000)\d+)?$/i.test(value)
    ? 'Invalid amount'
    : undefined
export const email = (value) =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,20}$/i.test(value)
    ? 'Invalid email address'
    : undefined

export const contactNumber = (value) =>
  value && !/^[0-9,]+$/i.test(value) ? 'Invalid Contact number' : undefined

export const contactNumberOrEmpty = (value) => {
  if (!value) {
    return
  }

  return value && !/^[0-9,]+$/i.test(value) || value.length!==10
    ? 'Invalid Contact number'
    : undefined
}

export const gsxReferenceNumber = (value) =>
  value && !(value.startsWith('G') || value.startsWith('D'))
    ? 'Not A valid GSX Reference Number Should Start with G or D.'
    : undefined

export const alphaNumeric = (value) =>
  value && /[^a-zA-Z0-9, ]/i.test(value)
    ? 'Only alphanumeric characters'
    : undefined

export const anyThingButAsterisk = (value) =>
  value && value.indexOf('*') >= 0 ? '* is not allowed' : undefined

export const phoneNumber = (value) =>
  value && !/^(0|[1-9][0-9]{9})$/i.test(value)
    ? 'Invalid phone number, must be 10 digits'
    : undefined
